"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePSD = exports.isPSD = void 0;
function isPSD(buffer) {
    return ('8BPS' === buffer.toString('ascii', 0, 4));
}
exports.isPSD = isPSD;
function calculatePSD(buffer) {
    return {
        width: buffer.readUInt32BE(18),
        height: buffer.readUInt32BE(14)
    };
}
exports.calculatePSD = calculatePSD;
